import { DateTime } from 'luxon';

import { REPORT_CONFIGURATION_QUERY_PARAMETER_KEY } from 'lib/hooks/reports/useLoadSavedReportFromUrl';

import routes from 'constants/routes';

import { SearchResultType } from 'common/generated/graphql';

export const getRouteForResultType = (type: SearchResultType, id: string) => {
  const { pathname } = window.location;
  const isInReports = pathname.startsWith(routes.reports.path);

  const startOfTheYearISO = DateTime.local().startOf('year').toISODate();

  const resultTypeRoutesMap: Record<SearchResultType, string> = {
    [SearchResultType.ACCOUNT]: routes.accounts.accountDetails({ id }),
    [SearchResultType.MERCHANT]: routes.merchants({
      id,
      queryParams: { date: startOfTheYearISO, timeframe: 'year' },
    }),
    [SearchResultType.GOAL]: routes.goalsV2.goalDetail({ id }),
    [SearchResultType.CATEGORY]: routes.categories({
      id,
      queryParams: { date: startOfTheYearISO, timeframe: 'year' },
    }),
    [SearchResultType.REPORT_CONFIGURATION]: isInReports
      ? // Just add the saved report ID to the current path
        `${pathname}?${new URLSearchParams({ [REPORT_CONFIGURATION_QUERY_PARAMETER_KEY]: id }).toString()}`
      : // Otherwise, navigate to the main reports path with the saved report ID
        routes.reports({ queryParams: { [REPORT_CONFIGURATION_QUERY_PARAMETER_KEY]: id } }),
  };

  return resultTypeRoutesMap[type];
};
